import { ECampaignPagesError } from "app/pages/digital-marketing/keywords-campaigns/wizard/campaigns-wizard/types";

const MAX_URL_LENGTH = 2048;

export const isValidUrl = (urlString: string) => {
    try {
        const validatedURL = urlString
            .toLowerCase()
            ?.trim()
            ?.replace("http://", "")
            ?.replace("https://", "")
            ?.split("?")?.[0];
        const domain = validatedURL?.match(/^(.*:\/\/)?(www\.)?([.\-_a-zA-Z0-9]*)(\/?).*$/);
        const lastIndexOfDot = domain[3].lastIndexOf(".");
        return lastIndexOfDot > 0 && domain[3].slice(lastIndexOfDot)?.length > 2;
    } catch (error) {
        return false;
    }
};

const getInputErrorSelectedSite = (url: string): ECampaignPagesError | null => {
    if (!url || url?.length === 0) {
        return ECampaignPagesError.EMPTY_FIELD;
    } else if (url?.length > MAX_URL_LENGTH) {
        return ECampaignPagesError.SITE_MAX_LENGTH;
    } else if (!isValidUrl(url)) {
        return ECampaignPagesError.INVALID_TEXT;
    }
    return null;
};

export const getSiteURLError = (siteName?: string): ECampaignPagesError | null => getInputErrorSelectedSite(siteName);
